// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"47":"bda4bdfddef5b3ac7547","87":"5a03a1876368374cf660","124":"075c2e8781e5dc6954cf","278":"dd9b88d9bcefe5831f64","289":"d97892b89881061f634b","444":"5be21abbf2cbdfcb5592","548":"f2c49dd0c8c5e38da961","898":"5a649c8f17fea7eaeb8a","924":"39df58cc4193c3e721d4"}[chunkId] + ".bundle.js";
};